module.exports = __webpack_public_path__ + "img/20210610-IMG_05831.e51ddd48.jpg";